import * as React from "react";
import C from "classnames";
export const CardBody = (props) => {
    return (React.createElement("div", { className: C("card-body", props.className), "data-testid": props.testId }, props.children));
};
//# sourceMappingURL=CardBody.js.map